import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from '../services/SharedService';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

  private noRole: boolean;

  constructor(private authService: AuthService,
    private router: Router,
    private sharedsvc: SharedService) { }

  ngOnInit(): void {
    try {
      this.authService.completeAuthentication().then(() => {
        let userProfile = this.authService.getClaims();
        this.sharedsvc.email = userProfile.unique_name;
        let userName = userProfile.family_name + ', ' + userProfile.given_name;
        this.sharedsvc.changeUserName(userName);
        this.sharedsvc.updateNoRole(!userProfile || !userProfile.roles || userProfile.roles.length <= 0);
        let url = localStorage.getItem('redirectUrl');
        this.sharedsvc.noRoleObs.subscribe(noRole => {
          this.noRole = noRole
        });
        if (url && !this.noRole) {
          if (url.indexOf('?') > -1) {
            let path = url.substring(0, url.indexOf('?'));
            let Params = url.substring(url.indexOf('?') + 1);
            let paramsItem = Object.fromEntries(new URLSearchParams(Params));
            this.router.navigate([path], { queryParams: paramsItem });
          }
          else {
            this.router.navigate([url]);
          }
          localStorage.setItem('redirectUrl', ''); // empty the redirectUrl
        }
        else {
          this.router.navigate(['/']);
        }

      });
    }
    catch (e) {
      this.sharedsvc.errorMessage = (e as Error).message;
      this.router.navigate(['error']);
    }
  }

}
